export interface RatesRejectedCountriesInput {
  risk: string;
  lang: string;
}
